"use client";
import { useEffect, useState } from "react";

// Razorpay types
declare global {
	interface Window {
		Razorpay: any;
	}
}

// Load Razorpay script
export function loadRazorpayScript(): Promise<boolean> {
	return new Promise((resolve) => {
		if (typeof window === "undefined") {
			resolve(false);
			return;
		}

		if (window.Razorpay) {
			resolve(true);
			return;
		}

		const script = document.createElement("script");
		script.src = "https://checkout.razorpay.com/v1/checkout.js";
		script.async = true;
		script.onload = () => resolve(true);
		script.onerror = () => resolve(false);
		document.body.appendChild(script);
	});
}

export function useRazorpay() {
	const [isLoaded, setIsLoaded] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		loadRazorpayScript()
			.then((loaded) => {
				setIsLoaded(loaded);
				if (!loaded) {
					setError(new Error("Failed to load Razorpay SDK"));
				}
			})
			.catch((err) => {
				setError(err);
				setIsLoaded(false);
			});
	}, []);

	return {
		isLoaded,
		error,
		Razorpay: typeof window !== "undefined" ? window.Razorpay : null,
	};
}

// Legacy export for compatibility
export function useStripe() {
	const { isLoaded, error } = useRazorpay();
	return { stripe: null, isLoading: !isLoaded, error };
}
